import { Heading, Text } from '@apollo/orbit';
import React from 'react';

type Props = {
  icon?: React.ReactElement<SVGElement>;
  title: React.ReactNode;
  description: React.ReactNode;
  children?: React.ReactNode;
};

export const EmptyState = ({ icon, title, description, children }: Props) => {
  return (
    <div className="flex h-fit max-w-screen-sm flex-col items-center gap-6 rounded-lg border border-primary bg-primary-inverted px-8 py-12">
      {icon && (
        <>
          {React.cloneElement(icon, {
            className: `h-16 w-40 flex-shrink-0`,
          })}
        </>
      )}
      <div className="flex flex-col items-center gap-3 text-center">
        <Heading size="xl">{title}</Heading>
        <Text variant="body">{description}</Text>
      </div>
      {children}
    </div>
  );
};
